import React, { useContext } from "react";
import CustomSelect from "shared/components/FormElements/Select";
import { StoreContext } from "shared/context/store-context";

const EducationYearSelector = ({ style = {}, compact = false }) => {
  const { educationYearsOptions, selectedEducationYearId, UpdateSelectedEducationYearId } = useContext(StoreContext);

  const handleChange = (_label, value) => {
    if (value) {
      UpdateSelectedEducationYearId(value);
    }
  };

  return (
    <div style={{ width: compact ? "140px" : "200px", marginTop: "1rem", ...style }}>
      <CustomSelect
        options={educationYearsOptions}
        id="year"
        onInput={handleChange}
        label=""
        initialValid={true}
        initialValue={educationYearsOptions.find((year) => year.value === selectedEducationYearId)}
      />
    </div>
  );
};

export default EducationYearSelector;
